import React, { Fragment } from 'react'
import {
    Grid,
    Typography,
    TextField
} from '@mui/material'
import { ModalReturnType } from '../../../hooks/useModal'
import { Modal } from '../../../components/_EOS/Modal'
import { putFinishASN } from '../config/api'
import { useApi } from '../../../hooks/useApi'
import { AsnBlogCreate } from '../../../interfaces/Asn/AsnBlog'
import { useUser } from '../../../hooks/useUser'
import { Status } from '../../../hooks/useFetchState'
import { Loading } from '../../../components/UI'



interface ASNReleaseModalProps {
    asnAdjustmentModalState: ModalReturnType<{
        workOrderId: number
        asnId: number
        asnNumber: string
    }>
    open: boolean
    onClose: () => void
    handleSnackbar: (message: string, success: boolean) => void
    refetchGridData: () => void
}

export const ASNReleaseModal: React.FC<ASNReleaseModalProps> = ({
    asnAdjustmentModalState,
    open,
    onClose,
    handleSnackbar,
    refetchGridData
}) => {

    const [asnBlogEntry, setAsnBlogEntry] = React.useState('')
    const { state, callApi } = useApi()
    const { userDataState: { userData } } = useUser()
    const isLoading = state.status === Status.Loading
    let workOrderId = (asnAdjustmentModalState.extendedProps?.workOrderId || 0)


    const handleAddComment = (e: any) => {
        e.preventDefault()
        setAsnBlogEntry(e.target.value)
    }


    const handleConfirmReleaseASN = () => {

        const asnBlogCreateDto: AsnBlogCreate = {
            asnId: asnAdjustmentModalState.extendedProps?.asnId || 0,
            comments: asnBlogEntry,
            createdUserId: userData?.userId || 0,
            asnNumber: asnAdjustmentModalState.extendedProps?.asnNumber
        }

        callApi(putFinishASN(workOrderId, asnBlogCreateDto.createdUserId, asnBlogCreateDto))
            .then(() => {
                handleSnackbar('ASN Liberada de manera correcta', true)
                refetchGridData()
                handleClose()
            })
            .catch((error) => {
                handleSnackbar(error, false)
            })
    }

    const handleClose = () => {
        if (isLoading)
            return
        setAsnBlogEntry('')
        onClose()
    }

    return (
        <Modal
            open={open}
            onClose={handleClose}
            title='Confirmación'
            successButton={{
                action: () => handleConfirmReleaseASN(),
                title: 'Guardar',
                disabled: asnBlogEntry.trim().length === 0

            }}

            cancelButton={{
                action: handleClose,
                title: 'Cancelar'
            }}
        >
            {isLoading ? (
                <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: '50vh' 
                }}>
                    <Loading />
                    <Typography style={{ marginTop: '16px' }}>
                        Liberando ASN, por favor espere...
                    </Typography>
                </div>
            ) : (
                <Fragment>
                    <Grid item xs={12}>
                        <Typography align='left' variant='h6'>
                            ¿Está seguro que desea finalizar esta ASN?
                        </Typography>

                        <Typography
                            component="div"
                            align='left'
                            variant='subtitle1'
                        >
                            Para finalizar, es necesario declarar los ajustes previos por diferencias de mercadería.
                        </Typography>

                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            value={asnBlogEntry}
                            onChange={handleAddComment}
                            variant='outlined'
                            multiline
                            placeholder='Ingrese comentario en la bitácora'
                            rows={4}
                            fullWidth
                            required={true}
                            error={asnBlogEntry.trim().length === 0}
                            helperText={
                                asnBlogEntry.trim().length === 0
                                    ? 'El campo Observaciones es requerido.'
                                    : ''
                            }
                            disabled={state.status === Status.Loading}
                        />
                    </Grid>
                </Fragment>
            )}
        </Modal>
    )
}